import {
  BrainCircuit, Store, Building2, Bus, ShieldCheck, Cog,
  Lightbulb, Rocket, TrendingUp, Wallet, Globe2, Target,
  CheckCircle2, ArrowRight, Calendar, FileSignature, Activity, Car,
  Mail, CreditCard, Landmark, Users, Gauge, UserRound, BarChart3,
  Database, Lock, Layers3, ClipboardList, Folder, Phone, MapPin, MessageSquare,
  Send, Menu, X, Edit3, Trash2, Plus, Save, LogOut, ListChecks, FileEdit, RotateCcw,
  Eye, EyeOff,
} from "lucide-react";

const MAP = {
  BrainCircuit, Store, Building2, Bus, ShieldCheck, Cog,
  Lightbulb, Rocket, TrendingUp, Wallet, Globe2, Target,
  CheckCircle2, ArrowRight, Calendar, FileSignature, Activity, Car,
  Mail, CreditCard, Landmark, Users, Gauge, UserRound, BarChart3,
  Database, Lock, Layers3, ClipboardList, Folder, Phone, MapPin, MessageSquare,
  Send, Menu, X, Edit3, Trash2, Plus, Save, LogOut, ListChecks, FileEdit, RotateCcw,
  Eye, EyeOff,
};

export const ICON_NAMES = Object.keys(MAP);

export default function Icon({ name, ...props }) {
  const Cmp = MAP[name] || Target;
  return <Cmp {...props} />;
}
